import styled from 'styled-components'

export const SelectPaymentMethodCategoryStepStyled = styled.div`
  height: 100%;

  display: flex;
  flex-direction: column;
`
